'use strict';

(function () {
  angular.module('zp').service('vendorsService', vendorsService);

  /**@ngInject */
  function vendorsService(zpAPI, $http, $q, config, VenueModel, $localStorage) {

    var service = this;
    var gridConfig = null;
    var vendorsCache = null;

    service.getAll = getAll;
    service.getVendors = getVendors;
    service.getRandom = getRandom;
    service.getOne = getOne;
    service.favourite = favourite;
    service.like = like;
    service.getGridConfig = getGridConfig;
    service.getOneBySlugs = getOneBySlugs;

    /////////////////////////////////////

    function getAll() {
      if (vendorsCache) {
        return $q.when(function () {
          return vendorsCache;
        }());
      }

      return $http({
        method: 'GET',
        url: '/data/vendors.json'
      }).then(function (response) {
        vendorsCache = response.data;
        return vendorsCache;
      });
    }

    function getVendors(category, latitude, longitude, radius) {
      return zpAPI.http({
        method: 'GET',
        url: getVendorsUrl(category) + '?lat=' + latitude + '&lng=' + longitude + '&radius=' + radius
      }).then(function (response) {
        var result = [];
        for (var i = 0; i < response.length; i++) {
          if (response[i].name === 'Đurđevdan i Sonata Open Concept') {
            continue;
          }
          if (category === 'prostori') {
            result.push(new VenueModel(response[i], 2));
          } else {
            var vm = new VenueModel();
            vm.fromVendorRaw(response[i], 2);
            result.push(vm);
          }
        }
        return result;
      });
    }

    function getOne(vendorId, category) {
      return zpAPI.http({
        method: 'GET',
        url: getVendorsUrl(category) + '/' + vendorId
      }).then(function (response) {
        if (category === 'prostori') {
          return new VenueModel(response);
        } else {
          var vm = new VenueModel();
          vm.fromVendorRaw(response);
          return vm;
        }
      });
    }

    function getOneBySlugs(category, slugCity, slugName) {
      return zpAPI.http({
        method: 'GET',
        url: '/vendors/' + category + '/' + slugCity + '/' + slugName
      }).then(function (response) {
        if (category === 'prostori') {
          return new VenueModel(response);
        } else {
          var vm = new VenueModel();
          vm.fromVendorRaw(response);
          return vm;
        }
      });
    }

    function getRandom(category, count) {
      count = count ? count : 1;
      var root = category === 'prostori' ? '/venues' : '/vendors/' + category;
      return zpAPI.http({
        method: 'GET',
        url: root + '/random/' + count
      }).then(function (response) {
        var result = [];
        for (var i = 0; i < response.length; i++) {
          if (category === 'prostori') {
            result.push(new VenueModel(response[i]));
          } else {
            var vm = new VenueModel();
            vm.fromVendorRaw(response[i]);
            result.push(vm);
          }
        }
        return result;
      });
    }

    function favourite(vendor, category) {
      var url = getVendorsUrl(category);
      return zpAPI.http({
        method: 'POST',
        url: url + '/' + vendor.id + '/favourite'
      }).then(function (response) {
        if (category === 'prostori') {
          return new VenueModel(response);
        } else {
          var vm = new VenueModel();
          vm.fromVendorRaw(response);
          return vm;
        }
      });
    }

    function like(vendor, category) {
      if ($localStorage.likes && $localStorage.likes[category] && $localStorage.likes[category].indexOf(vendor.id) !== -1) {
        return $q.reject('Vi ste već lajkovali ' + vendor.name);
      }
      var url = getVendorsUrl(category);
      return zpAPI.http({
        method: 'POST',
        url: url + '/' + vendor.id + '/like'
      }).then(function (response) {
        if (!$localStorage.likes) {
          $localStorage.likes = {};
        }
        if (!$localStorage.likes[category]) {
          $localStorage.likes[category] = [];
        }
        $localStorage.likes[category].push(vendor.id);
        if (category === 'prostori') {
          return new VenueModel(response);
        } else {
          var vm = new VenueModel();
          vm.fromVendorRaw(response);
          return vm;
        }
      });
    }

    function getVendorsUrl(category) {
      var url;
      switch (category) {
        case 'prostori':
          url = config.zpAPI.defaultRoutes.VENUES;
          break;
        case 'bendovi':
          url = config.zpAPI.defaultRoutes.BANDS;
        default:
          url = config.zpAPI.defaultRoutes.VENDORS + '/' + category;
          break;
      }
      return url;
    }

    function getGridConfig(city, vendor) {
      var urlQuery = '?';
      if (city) {
        urlQuery += 'city=' + city;
      }
      if (vendor) {
        urlQuery += '&vendor=' + vendor;
      }
      var url = '/vendors/grid/config' + urlQuery;
      return zpAPI.http({
        method: 'GET',
        url: url
      }).then(function (response) {
        gridConfig = response;
        return gridConfig;
      });
    }
  }
})();